import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=fbfd2520&scoped=true&"
import script from "@/scripts/Points/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Points/index.js?vue&type=script&lang=js&"
import style0 from "./Points.vue?vue&type=style&index=0&id=fbfd2520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfd2520",
  null
  
)

export default component.exports